import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid } from 'semantic-ui-react';

class EditPurchaserAddress extends React.Component {
  state = {
    error: '',
    load: false,
    message: '',
  };

  componentDidMount() {
    this.setState({
      address: this.props.editaddress,
      id: this.props.editid,
      state: this.props.editstate,
      gstn: this.props.editgstn,
    })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit() {
    let context = this;
    let address = this.state.address;
    let gsth = this.state.gstn;
    let state = this.state.state;
    let id = this.state.id;
    if (address == '' || address == undefined || address == null) {
      context.setState({
        error: 'Enter the Purchaser Address!!!'
      })
      return;
    }
    if (gsth == '' || gsth == undefined || gsth == null) {
      context.setState({
        error: 'Enter the Purchaser GSTN!!!'
      })
      return;
    }
    if (state == '' || state == undefined || state == null) {
      context.setState({
        error: 'Enter the Purchaser State!!!'
      })
      return;
    }
    context.setState({
      load: true,
      message: 'Add Purchaser!!!'
    })
    let data1 = { 'purchaser_id': id, 'address': address, 'state': state, 'gstn': gsth };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/editpurchasersaddress.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.getPurchaserAddress();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false,
        });
      }
    });
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog
          fullScreen={fullScreen}
          open={this.props.editPurchaserAddress}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle style={{width: 500}} id="responsive-dialog-title">{"Edit Address"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <form noValidate autoComplete="off">
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="Address"
                      value={this.state.address}  onChange={this.handleChange('address')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="GSTN"
                      value={this.state.gstn}  onChange={this.handleChange('gstn')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <TextField
                      id="outlined-name" label="State"
                      value={this.state.state}  onChange={this.handleChange('state')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                </Grid>
              </form>
              <center style={{color: 'red'}}>{this.state.error}</center>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="secoundary">
              Cancel
            </Button>
            <Button onClick={this.submit.bind(this)} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EditPurchaserAddress.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(EditPurchaserAddress);
